import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requirePermission } from '@/app/guards';
import { RolePage } from '@/features/admin';

/** New role, optionally copied from an existing one (?copyFrom=role-sales). */
export const Route = createFileRoute('/_app/admin_/roles/new')({
  validateSearch: z.object({ copyFrom: z.string().optional().catch(undefined) }),
  staticData: { crumb: 'admin:roles.newRole', crumbParents: [{ crumb: 'nav.setup', to: '/setup' }, { crumb: 'admin:nav.roles', to: '/admin/roles' }] },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.roles', 'Setup'),
  component: function NewRole() {
    const { copyFrom } = Route.useSearch();
    const navigate = Route.useNavigate();
    return <RolePage copyFrom={copyFrom} onCreated={(id) => void navigate({ to: '/admin/roles/$roleId', params: { roleId: id }, replace: true })} />;
  },
});
